exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-button {\r\n  padding:1.2em;\r\n  width:100%;\r\n  cursor:pointer;\r\n  margin-bottom:15px;\r\n  font-size:1.3em;\r\n}\r\n.alc {\r\n  text-align:center;\r\n  display:block;\r\n  margin: 15px 0;\r\n}\r\n\r\nbody {\r\n  background:#E2E4E6;\r\n  padding-top:4em;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/angular/ecell-hcst/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = 1